module.exports = __webpack_public_path__ + "img/Scooter_Right.7db82279.gif";